module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-bar"
  }, [_c('div', {
    staticClass: "footer-bar-nav"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/mikmak-logo-white-new.png"),
      "alt": "MikMak"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-bar-nav-links"
  }, [_c('a', {
    attrs: {
      "href": "http://mikmak.tv#attach"
    }
  }, [_vm._v("Platform")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://mikmak.tv#studios"
    }
  }, [_vm._v("Studios")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://mikmak.tv#press"
    }
  }, [_vm._v("Press")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/about'
    }
  }, [_vm._v("about")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/careers'
    }
  }, [_vm._v("careers")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/privacy'
    }
  }, [_vm._v("privacy policy")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "footer-copyright"
  }, [_vm._v("© 2015-2018 TIPO Entertainment, Inc.")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "footer-social-icons"
  }, [_c('a', {
    attrs: {
      "href": "https://instagram.com/MikMakTV/",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/MikMakdotTV",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/mikmaktv",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCGT0qpoynvsBolIES_xAr0w",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube-play",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d7bcf02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/FooterBar.vue
// module id = 483
// module chunks = 0